<mat-option>
  <ngx-mat-select-search
    [formControl]="filtroCtrl"
    (searchProperty)="searchProperty"
    i18n-placeholderLabel
    noEntriesFoundLabel="'Nenhum item encontrado!'"
    i18n-noEntriesFoundLabel
    placeholderLabel="Buscar...">
  </ngx-mat-select-search>
</mat-option>
